import { z } from "zod";
import { useNavigate } from "react-router";
import {
  FormContainer,
  PageContainer,
  Button,
  RequiredMessage,
  Input,
  Txt,
  Select,
  Checkbox,
} from "../../../components";
import { usuariosApi } from "../../../services";
import Alert from "../../../helpers/Alert";
import { useForm } from "../../../hooks";
import { useState } from "react";
import { tw } from "@matheuscaetano/helprs";

export default function UsuarioForm() {
  const navigate = useNavigate();

  const [changePassword, setChangePassword] = useState(true);

  // get professor_id from query params
  const queryParams = new URLSearchParams(window.location.search);
  const professor_id = queryParams.get("professor_id");

  const useFormData = useForm({
    loader: usuariosApi.one,
    loaded(data) {
      setChangePassword(false);
      return data;
    },
  });

  async function handleSubmit() {
    const rules = {
      nome: z.string().min(2),
      email: z.string().email(),
    } as any;

    if (changePassword) {
      rules.password = z.string().min(6);
      rules.password_confirmation = z
        .string()
        .refine(
          (val: string | undefined) =>
            useFormData.form.password?.trim() &&
            val?.trim() === useFormData.form.password?.trim(),
          { message: "As senhas não conferem" }
        );
    }

    if (!useFormData.validateWithZod(z.object(rules))) return;

    useFormData.setLoading(true);
    const response = await usuariosApi.save({
      ...useFormData.form,
      professor_id: professor_id ? parseInt(professor_id) : undefined,
    } as any);
    useFormData.setLoading(false);
    if (response.isError) {
      return Alert.error(response.data.message || "Falha ao salvar usuário");
    }
    Alert.success("Usuário salvo com sucesso");
    navigate("/usuarios");
  }

  return (
    <PageContainer>

      <FormContainer title="Cadastro de usuário" onSubmit={handleSubmit}>
        <p className="text-sm mb-4 bg-yellow-500/20 border border-yellow-500 p-2">
          ATENÇÃO: Essa tela não salva dados editados na tela de edição do professor
        </p>

        <div className="grid gap-4 md:grid-cols-2">
          <Input required label="Nome" {...useFormData.register("nome")} />

          <Input required label="E-mail" {...useFormData.register("email")} />

          <Input
            label="Telefone"
            mask="cellphone"
            {...useFormData.register("telefone")}
          />

          <Select
            label="Status"
            options={[
              { value: "Ativo", label: "Ativo" },
              { value: "Inativo", label: "Inativo" },
            ]}
            {...useFormData.register("status", {
              getValue: () => (useFormData.form.status ? "Ativo" : "Inativo"),
              setValue: (value) =>
                useFormData.setForm((f) => ({
                  ...f,
                  status: value === "Ativo" ? 1 : 0,
                })),
            })}
          />

          {useFormData.form.id && (
            <Checkbox
              label="Alterar senha"
              className="col-span-full mt-5"
              value={changePassword}
              setValue={setChangePassword}
            />
          )}

          <div
            className={tw(
              "grid gap-4 md:grid-cols-2 col-span-full",
              changePassword ? "" : "opacity-30 pointer-events-none"
            )}
          >
            <Input
              disabled={!changePassword}
              label="Senha"
              type="password"
              {...useFormData.register("password")}
            />

            <Input
              disabled={!changePassword}
              label="Confirmação da Senha"
              type="password"
              {...useFormData.register("password_confirmation")}
            />
          </div>
        </div>

        <footer className="col-span-full flex flex-col md:flex-row items-center md:items-end md:justify-between mt-6">
          <RequiredMessage />

          <div className="flex gap-4">
            <Button
              loading={useFormData.loading}
              type="submit"
              variant="confianca"
            >
              Salvar
            </Button>
          </div>
        </footer>
      </FormContainer>
    </PageContainer>
  );
}
